import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Night = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 28C23.35 28 22 26.65 22 25C22 23.35 23.35 22 25 22C26.65 22 28 23.35 28 25C28 26.65 26.65 28 25 28ZM25 24C24.45 24 24 24.45 24 25C24 25.55 24.45 26 25 26C25.55 26 26 25.55 26 25C26 24.45 25.55 24 25 24Z" />
		<path d="M21 18C20.45 18 20 17.55 20 17C20 14.238 17.762 12 15 12C14.45 12 14 11.55 14 11C14 10.45 14.45 10 15 10C17.762 10 20 7.763 20 5C20 4.45 20.45 4 21 4C21.55 4 22 4.45 22 5C22 7.763 24.238 10 27 10C27.55 10 28 10.45 28 11C28 11.55 27.55 12 27 12C24.238 12 22 14.238 22 17C22 17.55 21.55 18 21 18ZM18.6 11C19.575 11.588 20.413 12.412 21 13.4C21.587 12.425 22.413 11.587 23.4 11C22.425 10.412 21.587 9.588 21 8.6C20.413 9.588 19.587 10.413 18.6 11Z" />
		<path d="M11 28C10.45 28 10 27.55 10 27C10 24.238 7.763 22 5 22C4.45 22 4 21.55 4 21C4 20.45 4.45 20 5 20C7.763 20 10 17.762 10 15C10 14.45 10.45 14 11 14C11.55 14 12 14.45 12 15C12 17.762 14.238 20 17 20C17.55 20 18 20.45 18 21C18 21.55 17.55 22 17 22C14.238 22 12 24.238 12 27C12 27.55 11.55 28 11 28ZM8.6 21C9.575 21.587 10.413 22.413 11 23.4C11.588 22.425 12.412 21.587 13.4 21C12.425 20.413 11.587 19.587 11 18.6C10.412 19.588 9.588 20.413 8.6 21Z" />
		<path d="M7 10C5.35 10 4 8.65 4 7C4 5.35 5.35 4 7 4C8.65 4 10 5.35 10 7C10 8.65 8.65 10 7 10ZM7 6C6.45 6 6 6.45 6 7C6 7.55 6.45 8 7 8C7.55 8 8 7.55 8 7C8 6.45 7.55 6 7 6Z" />
	</svg>
);

export default Night;
